import React from 'react';
import styles from './SystemMessage.module.css';
import type { ChatMessage } from '../../types/foreman';

interface SystemMessageProps {
  message: ChatMessage;
}

function formatTime(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}

const SystemMessage: React.FC<SystemMessageProps> = ({ message }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.divider}>
        <span className={styles.line} />
        <span className={styles.content}>
          {message.content}
          {message.timestamp && (
            <span className={styles.timestamp}>{formatTime(message.timestamp)}</span>
          )}
        </span>
        <span className={styles.line} />
      </div>
    </div>
  );
};

export default SystemMessage;
